<template lang="html">
<Cell value="内容" v-if="detail.store.sstore_name">
    <div slot="title">
        <span class="custom-title col-fcGreyish size-24 marginr-10">送至</span>
        <span class="custom-title col-fcRed">{{detail.store.store_city}}</span>
    </div>
    <div slot="default" class="size-24">
        <span class="col-fcRed ">{{detail.delivery_goods.vendor_address}}</span>
        <span class="col-black333">发货, 运费约</span>
        <span class="col-fcRed">￥{{detail.delivery_goods.delivery_price}}</span>
    </div>
</Cell>
</template>

<script>
import {
    Cell
} from 'vant'
export default {
    name: 'deliveryGoodsBox',
    props: {
        detail : {
            type: Object,
            default () {
                return {}
            }
        }
    },
    components: {
        Cell
    }
}
</script>

<style  lang="stylus" scoped >
@import '~@/assets/stylus/variables.styl'
@import '~@/assets/stylus/mixin.styl'
.goods-box
    background white

</style>
